import uuid from 'react-uuid';
import { getOptionLedgerSecurityName } from './getOptionName';
import { normalizeOptionsLedger } from './normalizeOptionsLedger';
import type { CaptableColumn } from '../components/captable-table/CaptableTable.props';

// Ledger rows that can replace their parent with hidden grants.
const splittableRows = (ledger: unknown) => {
  const rows = normalizeOptionsLedger(ledger);
  return rows && rows.length > 1 ? rows : undefined;
};

/** Columns Save replaces with hidden grants: virtual groups, and parents whose ledger can build them. */
export const isOptionLedgerParent = (column: CaptableColumn): boolean =>
  (column.options_ledger?.length ?? 0) > 1 && (column.id === null || splittableRows(column.options_ledger) !== undefined);

/** Builds hidden securities from the canonical ledger used by acceptance and grid parsing. */
export const buildOptionLedgerColumns = (
  columnsWithLedgers: CaptableColumn[],
  updatedColumns: CaptableColumn[],
  calculateDilutedOwnPercent: (shares: number) => unknown,
  calculateCurrentOwnPercent: (shares: number) => unknown
): CaptableColumn[] => columnsWithLedgers.flatMap(column => {
  // An invalid ledger stays on its parent, with no partial hidden breakdown.
  const rows = splittableRows(column.options_ledger) ?? [];
  return rows.flatMap((row, index) => row.security_ref ? [] : [{
    ...column,
    id: 0,
    security_ref: uuid(),
    name: getOptionLedgerSecurityName(rows, index, column.name),
    is_hidden: true,
    security_group_ref: column.security_ref,
    shares_diluted: row.shares,
    diluted_own_percent: Number(calculateDilutedOwnPercent(Number(row.shares))),
    shares_outstanding: row.shares,
    current_own_percent: Number(calculateCurrentOwnPercent(Number(row.shares))),
    strike_price: row.price,
    order: updatedColumns.findIndex(item => item.security_ref === column.security_ref),
  }]);
});
